import { IStatisticsResponse } from "@/services/backend-service";

export type AdEntryType = "text" | "image" | "icon";

export interface AdEntry {
  type: AdEntryType;
  content: string;
}

export interface AdItem {
  index: number;
  list: AdEntry[];
}

const USER_TREE_ICON = "/user-tree.svg";
const SEAL_CHECK_ICON = "/seal-check.svg";
const MONEY_ICON = "/money.svg";
const CONFETTI_ICON = "/confetti.svg";
const STAR_ICON = "/star.svg";

const stateCodeToName: Record<string, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const getTimeAgo = (date: string): string => {
  const timeAgo = Date.now() - new Date(date).getTime();
  const seconds = Math.floor(timeAgo / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} days`;
  } else if (hours > 0) {
    return `${hours} hours`;
  } else if (minutes > 0) {
    return `${minutes} minutes`;
  } else {
    return `${seconds} seconds`;
  }
};

export const buildHomeAds = (stats: IStatisticsResponse): AdItem[] => [
  {
    index: 0,
    list: [
      {
        content: USER_TREE_ICON,
        type: "image",
      },
      {
        content: `${stats.applicationsStarted.toLocaleString()} people started their application minutes ago`,
        type: "text",
      },
    ],
  },
  {
    index: 1,
    list: [
      {
        content: SEAL_CHECK_ICON,
        type: "image",
      },
      {
        content: `${stats.applicationsApproved.toLocaleString()} people were recently approved`,
        type: "text",
      },
    ],
  },
  {
    index: 2,
    list: [
      {
        content: MONEY_ICON,
        type: "image",
      },
      {
        content: `${stats.customerSavings.name} in ${stateCodeToName[stats.customerSavings.location] ?? stats.customerSavings.location} reduced their monthly payment by $${stats.customerSavings.amount.toLocaleString()}`,
        type: "text",
      },
    ],
  },
  {
    index: 3,
    list: [
      {
        content: CONFETTI_ICON,
        type: "image",
      },
      {
        content: `Last loan closed ${getTimeAgo(stats.lastLoanClosed)} ago`,
        type: "text",
      },
    ],
  },
  {
    index: 4,
    list: [
      {
        content: `${stats.siteRating.average}`,
        type: "text",
      },
      {
        content: STAR_ICON,
        type: "icon",
      },
      {
        content: `rated by ${stats.siteRating.totalReviews.toLocaleString()} homeowners`,
        type: "text",
      },
    ],
  },
];
